import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import * as React from 'react';
import styled from 'styled-components';

import { FormattedCurrency } from '@/components/Formatted/FormattedCurrency';
import { useAppSelector } from '@/redux/hooks';
import { getBidIncrementsByCatalogId } from '@/redux/modules/bidIncrements/bidIncrements.selectors';
import { getCatalogCurrency } from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { BidIncrement } from '@/types/BidIncrement';

import { DescriptionSection } from '../ItemDescription/DescriptionSection';

type Props = {
    catalogId: number;
};

const BidIncrements = ({ catalogId }: Props) => {
    const bidIncrements = useAppSelector((state) => getBidIncrementsByCatalogId(state, catalogId));
    const currency = useAppSelector((state) => getCatalogCurrency(state, catalogId));

    const mapBidIncrements = React.useCallback(
        (item: BidIncrement, index: number) => {
            return (
                <StyledRow key={index}>
                    <StyledRowItem>
                        <FormattedCurrency
                            convert
                            key={`bid-increment-from-amount-${index}`}
                            noFraction
                            sourceCurrency={currency}
                            value={item.fromAmount}
                        />
                    </StyledRowItem>
                    <StyledRowItem>
                        <FormattedCurrency
                            convert
                            key={`bid-increment-increment-amount-${index}`}
                            noFraction
                            sourceCurrency={currency}
                            value={item.incAmount}
                        />
                    </StyledRowItem>
                </StyledRow>
            );
        },
        [currency]
    );

    return (
        <DescriptionSection
            body={
                <StyledTable>
                    <StyledRow>
                        <StyledRowItem>
                            <StyledTitle>
                                <FormattedMessage id="price" />
                            </StyledTitle>
                        </StyledRowItem>
                        <StyledRowItem>
                            <StyledTitle>
                                <FormattedMessage id="bid_increment" />
                            </StyledTitle>
                        </StyledRowItem>
                    </StyledRow>
                    {bidIncrements.map(mapBidIncrements)}
                </StyledTable>
            }
            header="bid_increments"
        />
    );
};

export default React.memo<Props>(BidIncrements);

const StyledTable = styled.div`
    display: block;
    max-width: 380px !important;
`;

const StyledRow = styled.div`
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey400};
    padding: 9px 0;
`;

const StyledRowItem = styled.span`
    display: inline-block;
    max-width: 200px;
    width: 50%;
`;

const StyledTitle = styled.span`
    font-family: ${({ theme }) => theme.typography.fontPrimaryStrong};
`;
